export default __webpack_public_path__ + "static/HarmoniaSansProCyr-Regular-2590c4ce803bc5a782c67e3999679ca1.woff2";